import { PageShell } from "@/components/marketing/PageShell";
import { KeyRound, Pencil, Trash2, MessageSquareWarning } from "lucide-react";
import { useSiteContent } from "@/hooks/useSiteContent";
import { PrivacyRequestForm } from "@/components/marketing/PrivacyRequestForm";

const RIGHTS = [
  { icon: KeyRound, title: "Right of access", desc: "Request a copy of the personal data held about you and the evidence used in any report." },
  { icon: Pencil, title: "Right to correction", desc: "Ask us to correct inaccurate declared or evidence data, triggering a documented review." },
  { icon: Trash2, title: "Right to deletion", desc: "Request deletion of your data, subject to legal retention obligations and certified purge." },
  { icon: MessageSquareWarning, title: "Right to dispute", desc: "Challenge a report outcome; each request is tracked with a reinvestigation deadline." },
];

export default function SubjectRights() {
  const { contact } = useSiteContent();
  return (
    <PageShell eyebrow="— SUBJECT RIGHTS —" title="Your rights as a verification subject">
      <div className="rounded-3xl border border-gray-300/60 bg-oath-panel/50 p-3">
        <div className="grid gap-3 sm:grid-cols-2">
          {RIGHTS.map((r) => (
            <div key={r.title} className="rounded-2xl border border-gray-200 bg-white p-6" data-testid={`right-${r.title.split(" ").pop().toLowerCase()}`}>
              <span className="grid h-11 w-11 place-items-center rounded-xl bg-oath-accent-light text-oath-accent">
                <r.icon className="h-5 w-5" strokeWidth={1.75} />
              </span>
              <h3 className="mt-4 font-display text-lg font-bold text-oath-ink">{r.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-oath-secondary">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <p className="mt-6 text-sm text-oath-secondary">
        Use the form below to send a request — or email <span className="text-oath-accent" data-testid="rights-email">{contact.rights_email}</span> with your report ID.
        Every request gets a reference number and a 45-day response deadline.
      </p>
      <div className="mt-8"><PrivacyRequestForm source="subject_rights" title="Send a rights request" /></div>
    </PageShell>
  );
}
